import {
  ActivityProgress,
  CompanyRankDto,
  CountryActivityProgress,
  DivisionActivityProgress,
} from '../../services/api.types'
import { getFullName } from './translations'

export function getActivityProgressPercentageComparator(a: [string, ActivityProgress], b: [string, ActivityProgress]) {
  const percentageComparisonResult = b[1].totalPercentage - a[1].totalPercentage
  if (percentageComparisonResult !== 0) {
    return percentageComparisonResult
  }

  return ('' + getFullName(a[1].firstName, a[1].lastName, a[1].email)).localeCompare(
    getFullName(b[1].firstName, b[1].lastName, b[1].email),
  )
}

export function getActivityProgressPersistenceComparator(a: [string, ActivityProgress], b: [string, ActivityProgress]) {
  const percentageComparisonResult = b[1].persistenceTotal - a[1].persistenceTotal
  if (percentageComparisonResult !== 0) {
    return percentageComparisonResult
  }

  return ('' + getFullName(a[1].firstName, a[1].lastName, a[1].email)).localeCompare(
    getFullName(b[1].firstName, b[1].lastName, b[1].email),
  )
}

export function getActivityProgressStepsComparator(a: [string, ActivityProgress], b: [string, ActivityProgress]) {
  const percentageComparisonResult = b[1].stepsTotal - a[1].stepsTotal
  if (percentageComparisonResult !== 0) {
    return percentageComparisonResult
  }

  return ('' + getFullName(a[1].firstName, a[1].lastName, a[1].email)).localeCompare(
    getFullName(b[1].firstName, b[1].lastName, b[1].email),
  )
}

export function getActivityProgressCaloriesComparator(a: [string, ActivityProgress], b: [string, ActivityProgress]) {
  const percentageComparisonResult = b[1].caloriesTotal - a[1].caloriesTotal
  if (percentageComparisonResult !== 0) {
    return percentageComparisonResult
  }

  return ('' + getFullName(a[1].firstName, a[1].lastName, a[1].email)).localeCompare(
    getFullName(b[1].firstName, b[1].lastName, b[1].email),
  )
}

export function getActivityProgressMinutesComparator(a: [string, ActivityProgress], b: [string, ActivityProgress]) {
  const percentageComparisonResult = b[1].intensiveMinutesTotal - a[1].intensiveMinutesTotal
  if (percentageComparisonResult !== 0) {
    return percentageComparisonResult
  }

  return ('' + getFullName(a[1].firstName, a[1].lastName, a[1].email)).localeCompare(
    getFullName(b[1].firstName, b[1].lastName, b[1].email),
  )
}

export function getDivisionActivityProgressPercentageComparator(
  a: [string, DivisionActivityProgress],
  b: [string, DivisionActivityProgress],
) {
  const percentageComparisonResult = b[1].totalPercentage - a[1].totalPercentage
  if (percentageComparisonResult !== 0) {
    return percentageComparisonResult
  }

  return ('' + a[1].divisionName).localeCompare(b[1].divisionName)
}

export function getDivisionActivityProgressPersistenceComparator(
  a: [string, DivisionActivityProgress],
  b: [string, DivisionActivityProgress],
) {
  const percentageComparisonResult = b[1].persistenceTotal - a[1].persistenceTotal
  if (percentageComparisonResult !== 0) {
    return percentageComparisonResult
  }

  return ('' + a[1].divisionName).localeCompare(b[1].divisionName)
}

export function getDivisionActivityProgressStepsComparator(
  a: [string, DivisionActivityProgress],
  b: [string, DivisionActivityProgress],
) {
  const percentageComparisonResult = b[1].stepsTotal - a[1].stepsTotal
  if (percentageComparisonResult !== 0) {
    return percentageComparisonResult
  }

  return ('' + a[1].divisionName).localeCompare(b[1].divisionName)
}

export function getDivisionActivityProgressCaloriesComparator(
  a: [string, DivisionActivityProgress],
  b: [string, DivisionActivityProgress],
) {
  const percentageComparisonResult = b[1].caloriesTotal - a[1].caloriesTotal
  if (percentageComparisonResult !== 0) {
    return percentageComparisonResult
  }

  return ('' + a[1].divisionName).localeCompare(b[1].divisionName)
}

export function getDivisionActivityProgressMinutesComparator(
  a: [string, DivisionActivityProgress],
  b: [string, DivisionActivityProgress],
) {
  const percentageComparisonResult = b[1].intensiveMinutesTotal - a[1].intensiveMinutesTotal
  if (percentageComparisonResult !== 0) {
    return percentageComparisonResult
  }

  return ('' + a[1].divisionName).localeCompare(b[1].divisionName)
}

export function getCountryActivityProgressPercentageComparator(
  a: [string, CountryActivityProgress],
  b: [string, CountryActivityProgress],
) {
  const percentageComparisonResult = b[1].totalPercentage - a[1].totalPercentage
  if (percentageComparisonResult !== 0) {
    return percentageComparisonResult
  }

  return ('' + a[1].country).localeCompare(b[1].country)
}

export function getCountryActivityProgressPersistenceComparator(
  a: [string, CountryActivityProgress],
  b: [string, CountryActivityProgress],
) {
  const percentageComparisonResult = b[1].persistenceTotal - a[1].persistenceTotal
  if (percentageComparisonResult !== 0) {
    return percentageComparisonResult
  }

  return ('' + a[1].country).localeCompare(b[1].country)
}

export function getCountryActivityProgressStepsComparator(
  a: [string, CountryActivityProgress],
  b: [string, CountryActivityProgress],
) {
  const percentageComparisonResult = b[1].stepsTotal - a[1].stepsTotal
  if (percentageComparisonResult !== 0) {
    return percentageComparisonResult
  }

  return ('' + a[1].country).localeCompare(b[1].country)
}

export function getCountryActivityProgressCaloriesComparator(
  a: [string, CountryActivityProgress],
  b: [string, CountryActivityProgress],
) {
  const percentageComparisonResult = b[1].caloriesTotal - a[1].caloriesTotal
  if (percentageComparisonResult !== 0) {
    return percentageComparisonResult
  }

  return ('' + a[1].country).localeCompare(b[1].country)
}

export function getCountryActivityProgressMinutesComparator(
  a: [string, CountryActivityProgress],
  b: [string, CountryActivityProgress],
) {
  const percentageComparisonResult = b[1].intensiveMinutesTotal - a[1].intensiveMinutesTotal
  if (percentageComparisonResult !== 0) {
    return percentageComparisonResult
  }

  return ('' + a[1].country).localeCompare(b[1].country)
}

export function getBenefitsActivityProgressPercentageComparator(a: ActivityProgress, b: ActivityProgress) {
  const percentageComparisonResult = b.totalPercentage - a.totalPercentage
  if (percentageComparisonResult !== 0) {
    return percentageComparisonResult
  }

  return ('' + getFullName(a.firstName, a.lastName, a.email)).localeCompare(
    getFullName(b.firstName, b.lastName, b.email),
  )
}

export function getBenefitsActivityProgressStepsComparator(a: ActivityProgress, b: ActivityProgress) {
  const percentageComparisonResult = b.stepsTotal - a.stepsTotal
  if (percentageComparisonResult !== 0) {
    return percentageComparisonResult
  }

  return ('' + getFullName(a.firstName, a.lastName, a.email)).localeCompare(
    getFullName(b.firstName, b.lastName, b.email),
  )
}

export function getCompanyRankingPercentageComparator(a: [string, CompanyRankDto], b: [string, CompanyRankDto]) {
  const percentageComparisonResult = b[1].percentage - a[1].percentage
  if (percentageComparisonResult !== 0) {
    return percentageComparisonResult
  }

  return ('' + a[1].companyName).localeCompare(b[1].companyName)
}
